import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface SectionCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
}

const SectionCard = forwardRef<HTMLDivElement, SectionCardProps>(
  ({ className, title, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col gap-3 sm:gap-4 rounded-md border border-[#e8e8ec] bg-white/80 p-4 sm:p-5",
          className
        )}
        {...props}
      >
        <h2 className="text-base sm:text-lg font-semibold leading-6 sm:leading-[26px] tracking-[-0.04px] text-[#1c2024]">
          {title}
        </h2>
        {children}
      </div>
    );
  }
);

SectionCard.displayName = "SectionCard";

export { SectionCard };
